import Vue from 'vue'

import GetTextPlugin from 'vue-gettext'
import translations from './translations.json'
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import App from './App.vue'
import DcCarbonCalculator from "@/components/DcCarbonCalculator";
import $ from 'jquery'

// import VTooltip from 'v-tooltip'

// Vue.use(VTooltip);
Vue.use(Tooltip, {
  delay: 200,
  class: 'myTooltip',
  triggers: ['click'],
  offset: 0
});
Vue.use(GetTextPlugin, {
      availableLanguages: {
        de_DE: 'Deutsch',
        en: 'American English'
      },
      // defaultLanguage: getUrlParameter('lang'),
      defaultLanguage: getUrlParameter('lang')? getUrlParameter('lang') : getConfig("lang"),
      // defaultLanguage: getUrlParameter('lang')? getUrlParameter('lang') : getConfig("lang"),
      // defaultLanguage: "en",
      languageVmMixin: {
        computed: {
          currentKebabCase: function () {
            return this.current.toLowerCase().replace('_', '-')
          },
        },
      },
      translations: translations,
      silent: true
    }
)

Vue.config.productionTip = false
console.log("version", "20250110");
var vm = new Vue({
  components: {
    app: App,
    // el: '#app',
    "dcCarbonCalculator": DcCarbonCalculator
  },
  render: h => h(App),
}).$mount();
document.getElementsByClassName('gfDcCarbonCalculator')[0].appendChild(vm.$el);
global.myvm = vm;
window.myvm = vm;
window.mylang = getUrlParameter('lang')? getUrlParameter('lang').replace("_", "-") : getConfig("lang").replace("_", "-");
function getConfig(key)
{
  for (var i = 0; i < $(".gfDcCarbonCalculator app").data("config")["props"].length; ++i)
  {
    if (JSON.parse($(".gfDcCarbonCalculator app").data("config")["props"][i])["key"] == key)
    {
      return JSON.parse($(".gfDcCarbonCalculator app").data("config")["props"][i])["value"];
    }
  }
}
function getUrlParameter(sParam)
{
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++)
  {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam)
    {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
  return false;
}

String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};

